module.exports = __webpack_public_path__ + "img/int3_fet_rui_01.2a6d675c.jpg";